import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

import {
  Button,
  InputBase,
  InputAdornment,
  Typography,
  Link,
} from "@mui/material";

import { apiContext, apiDict } from "../../context/api-v1/api";
import UserAdminLayout from "../../components/userAdminLayout";
import Toast from "../../components/Toast";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import KeyIcon from "@mui/icons-material/Key";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import IconButton from "@mui/material/IconButton";
import { useTitle } from "../../utils/hooks";

export default function UserLogin() {
  useTitle("用户登录");
  return <UserLoginLayout />;
}

function UserLoginLayout() {
  const location = useLocation();

  const userDataRef = useRef({ usr: "", psd: "" });
  const navigate = useNavigate();
  const [statusCode, setStatusCode] = useState();
  const [userStatus, setUserStatus] = useState();
  const [jwtDatas, setJwtDatas] = useState("");

  const [psdShow, setPsdShow] = useState(false);

  const [msgBoxShow, setMsgBoxShow] = useState(false);
  const [msgTips, setMsgTips] = useState({});

  function handleInputUsr(e) {
    userDataRef.current.usr = e.target.value;
  }
  function handleInputPsd(e) {
    userDataRef.current.psd = e.target.value;
  }
  function handleSubmit() {
    const usr = userDataRef.current.usr;
    const psd = userDataRef.current.psd;

    if (!usr || !psd) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "请填写所有字段" });
    } else {
      const usrDatas = {
        username: usr,
        password: psd,
      };

      apiContext(
        apiDict.login,
        "POST",
        setJwtDatas,
        setStatusCode,
        usrDatas,
      );
    }
  }

  function handleMsgBoxClose() {
    setMsgBoxShow(false);
  }

  useEffect(() => {
    if (!statusCode) {
      return;
    }
    if (statusCode !== 200) {
      setMsgBoxShow(true);
      setMsgTips({ status: "error", msg: "登录错误, 请检查账户或密码" });
    } else {
      setMsgBoxShow(true);
      if (location.state && location.state.next) {
        setMsgTips({ status: "success", msg: "登录成功, 返回原页面" });
      } else {
        setMsgTips({ status: "success", msg: "登录成功, 跳转首页" });
      }

      localStorage.setItem("access", jwtDatas.access);

      apiContext(
        apiDict.userinfo,
        "GET",
        setUserStatus
      );
    }
  }, [jwtDatas]);

  useEffect(() => {
    if (!userStatus) {
      return;
    }

    localStorage.setItem("username", userStatus.username);
    localStorage.setItem("user_id", userStatus.id);
    setTimeout(() => {
      if (location.state && location.state.next) {
        navigate(location.state.next, {
          state: {
            next: location.state.next,
            articleDatas: location.state.articleDatas,
          },
        });
      } else {
        navigate("/");
      }
    }, 1500);
  }, [userStatus]);

  return (
    <UserAdminLayout>
      <IconButton
        sx={{
          position: "absolute",
          left: "1.5vw",
          top: "2vh",
        }}
        onClick={() => navigate("/")}
      >
        <HomeOutlinedIcon sx={{ fontSize: "1.5rem !important" }} />
      </IconButton>
      <Typography variant="h6" sx={{ mb: "20px", fontWeight: "600" }}>
        用户登录
      </Typography>
      <InputBase
        sx={{
          backgroundColor: "#babec2",
          borderRadius: "6px",
          width: "15vw",
          minWidth: "180px",
          height: "5vh",
          fontSize: "13px",
          mt: "20px",

          ".MuiInputBase-input": {
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "34px",
          },
        }}
        color="third"
        placeholder="username"
        required
        startAdornment={
          <InputAdornment position="start" sx={{ ml: "10px" }}>
            <HowToRegIcon />
          </InputAdornment>
        }
        onChange={handleInputUsr}
      />
      <InputBase
        sx={{
          backgroundColor: "#babec2",
          borderRadius: "6px",
          width: "15vw",
          minWidth: "180px",
          height: "5vh",
          fontSize: "13px",
          mt: "20px",

          ".MuiInputBase-input": {
            textAlign: "center",
            display: " flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "35px",
          },
        }}
        color="third"
        placeholder="password"
        type={psdShow ? "text" : "password"}
        required
        startAdornment={
          <InputAdornment position="start" sx={{ ml: "10px" }}>
            <KeyIcon fontSize="small" />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment
            position="end"
            sx={{ mr: "10px", cursor: "pointer" }}
            onClick={() => setPsdShow(!psdShow)}
          >
            {psdShow ? (
              <VisibilityIcon sx={{ fontSize: "13px" }} />
            ) : (
              <VisibilityOffIcon sx={{ fontSize: "13px" }} />
            )}
          </InputAdornment>
        }
        d
        onChange={handleInputPsd}
      />
      <Button
        variant="contained"
        onClick={handleSubmit}
        sx={{ mt: "30px", width: "10vw" }}
        color="fivth"
      >
        登录
      </Button>
      <Link
        onClick={() => navigate("/user/register")}
        sx={{
          color: "#6c5f57",
          fontSize: "10px",
          cursor: "pointer",
          mt: "15px",
        }}
      >
        Don't have account ?
      </Link>
      <Toast
        open={msgBoxShow}
        onClose={handleMsgBoxClose}
        severity={msgTips.status}
        message={msgTips.msg}
      />
    </UserAdminLayout>
  );
}
